import React, {useEffect, useRef, useState} from "react";
import {useStyles} from "../styles/OddListeningStepStyle";
import {
    Box,
    Button,
    Typography,
    Tabs,
    Tab,
    IconButton,
    Select,
    MenuItem,
    FormControl,
    Popover
} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import { ReactComponent as RefreshIcon } from '../../../../../common/images/RefreshIcon.svg';
import { ReactComponent as VolumeDisableIcon } from '../../../../../common/images/VolumeDisableIcon.svg';
import { ReactComponent as VolumeIcon } from '../../../../../common/images/VolumeIcon.svg';
import { ReactComponent as ArrowDownIcon } from '../../../../../common/images/ArrowDownIcon.svg';
import { ReactComponent as TooltipTipIcon } from '../../../../../common/images/TooltipTipIcon.svg';
import { ReactComponent as TooltipClose } from '../../../../../common/images/TooltipClose.svg';

import NoImage from '../../../../../common/images/NoImage.jpg';
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";
import AudioPlayer from "../../../../../components/AudioPlayer";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function OddStepTwo(props) {
    const classes = useStyles();

    const {contentStore,oddStepTwoStore,audioPlayerStore} = props;
    const {stepValue, dayValue} = props.contentStore;

    const anchorElRef = useRef(null);
    const imageRef = useRef(null);

    const onSave = () => {
        oddStepTwoStore.modifyOddStepTwoContent(stepValue, dayValue, () => {
            oddStepTwoStore.getOddStepTwoContent(stepValue,dayValue, processOddStepTwoContent);
            contentStore.setReadyToSaveStep(false);
        });
    }

    const processOddStepTwoContent = (res) => {
        const isCompleted = oddStepTwoStore.isOddStepTwoCompleted(res);
        contentStore.setReadyToMoveExit(isCompleted);
    }

    useEffect(() => {
        oddStepTwoStore.getOddStepTwoContent(stepValue,dayValue, processOddStepTwoContent)
        props.contentStore.setOnSave(onSave);
        return ()=> {
            props.contentStore.setOnSave(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleResize = () => {
        if (imageRef.current) {
            const imageWidth = imageRef.current.width;
            const imageHeight = imageRef.current.height;

            if (imageWidth === 0 || imageHeight === 0) {
                return;
            }

            oddStepTwoStore.positionList.forEach((position, index) => {
                const x = (position.x / 100) * imageWidth;
                const y = (position.y / 100) * imageHeight;
                const element = document.getElementById(`position-${index}`);

                if (element) {
                    element.style.left = `${x}px`;
                    element.style.top = `${y}px`;
                }
            });
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        window.addEventListener('dragover', handleDragOver);

        return () => {
            window.addEventListener('dragover', handleDragOver);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDragOver = (event) => {
        event.preventDefault();
    }

    const [anchorEl, setAnchorEl] = useState(0);
    const handleChange = (event, newValue) => {
        oddStepTwoStore.setContentTapIndex(newValue);
    };

    const generatePosition = (event) => {
        if (oddStepTwoStore.isProcessingPosition) {
            if (oddStepTwoStore.positionList.length === 0 || oddStepTwoStore.positionList.length === oddStepTwoStore.getPieceCount()) {
                oddStepTwoStore.setPositionList([]);
            }
            if (oddStepTwoStore.positionList.length < oddStepTwoStore.getPieceCount()) {
                const imageRect = imageRef.current.getBoundingClientRect();

                const xRelativeToImage = event.clientX - imageRect.left;
                const yRelativeToImage = event.clientY - imageRect.top;

                const imageWidth = imageRect.width;
                const imageHeight = imageRect.height;

                const x = (xRelativeToImage / imageWidth) * 100;
                const y = (yRelativeToImage / imageHeight) * 100;

                oddStepTwoStore.addPosition(x, y);
            }
        }
    };

    const handleClickSavePosition = () => {
        oddStepTwoStore.savePosition();
        oddStepTwoStore.setSelectedSubContent(0);
        oddStepTwoStore.setIsProcessingPosition(false);
        oddStepTwoStore.setPositionList([]);
        contentStore.setReadyToSaveStep(true);
    }

    const getPosition = (x, y) => {
        const imageRect = imageRef.current.getBoundingClientRect();

        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;

        const xPosition = imageWidth * x / 100;
        const yPosition = imageHeight * y / 100;

        return {
            x: xPosition,
            y: yPosition
        }
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const onChangeVoiceType = (e) => {
        oddStepTwoStore.setVoiceType(e.target.value);
    }

    const handleClickAudio = (id, startTime, endTime) => {
        oddStepTwoStore.playAudio(id, startTime, endTime);
    }

    const handleClickPieceAudio = (id, piece) => {
        if (piece.audioStartTime !== null) {
            oddStepTwoStore.playAudio(id, piece.audioStartTime, piece.audioEndTime);
        } else {
            if (piece.audio === undefined) {
                oddStepTwoStore.getPieceAudio(piece, (pieceAudio) => oddStepTwoStore.playPieceAudio(pieceAudio));
            } else {
                oddStepTwoStore.playPieceAudio(piece.audio);
            }
        }
    }

    const handleClickGeneratePosition = (seq) => {
        oddStepTwoStore.setSelectedSubContent(seq);
        oddStepTwoStore.setIsProcessingPosition(true);
        oddStepTwoStore.setPositionList();
        handleOpenPopover();
    }

    const handleClickGenerateSound = (seq) => {
        oddStepTwoStore.stopAudio();
        audioPlayerStore.setAudioRegionList([]);
        audioPlayerStore.setIsOpen(true);
        oddStepTwoStore.setSelectedSubContent(seq);
    }

    const handleCloseGenerateSound = () => {
        oddStepTwoStore.setSelectedSubContent(0)
        audioPlayerStore.setIsProcessing(false);
        audioPlayerStore.setSelectedAudioRegion(null);
    }

    const handleFinishGenerateSound = () => {
        oddStepTwoStore.setSubContentAudios(audioPlayerStore.audioRegionList);
        contentStore.setReadyToSaveStep(true);
    }

    const handleRefreshTTS = () => {
        oddStepTwoStore.stopAudio();
        contentStore.getGeneratedTTSWithAzure(oddStepTwoStore.getSelectedLangCode(), oddStepTwoStore.voiceType, oddStepTwoStore.selectedContent.text, oddStepTwoStore.changeMainAudio);
        contentStore.setReadyToSaveStep(true);
    }

    const handleOpenPopover = () => {
        setAnchorEl(anchorElRef.current);
        oddStepTwoStore.setPopoverState(true);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
        oddStepTwoStore.setPopoverState(null);
    };

    const handleDrag = (event) => {
        if (oddStepTwoStore.isProcessingPosition) {
            const index = event.target.id.split('-')[1];

            const imageRect = imageRef.current.getBoundingClientRect();

            const xRelativeToImage = event.clientX - imageRect.left;
            const yRelativeToImage = event.clientY - imageRect.top;

            const imageWidth = imageRect.width;
            const imageHeight = imageRect.height;

            const x = (xRelativeToImage / imageWidth) * 100;
            const y = (yRelativeToImage / imageHeight) * 100;

            oddStepTwoStore.setPosition(index, x, y);
        }
    }

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"flex-first"}>
                <Box className={classes.boxWrap}>
                    <Box>
                        <Box position="static" className={classes.tabBox}>
                            <Tabs value={oddStepTwoStore.contentTapIndex} onChange={handleChange} aria-label="simple tabs example">
                                <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                                <Tab label="영어" {...a11yProps(1)} disableRipple/>
                                <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                                <Tab label="중국어" {...a11yProps(3)} disableRipple/>
                            </Tabs>
                        </Box>
                        {Array.from({length: 4}, (_, i) => (
                            <TabPanel key={i} value={oddStepTwoStore.contentTapIndex} index={i} className={classes.textBox}>
                                <Box className={classes.selectBoxListening}>
                                    <Box display={"flex"} justifyContent={"flex-first"} alignItems={"center"} >
                                        <FormControl className={classes.formControl}>
                                            <Select
                                                value={oddStepTwoStore.voiceType}
                                                onChange={onChangeVoiceType}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                <MenuItem value='Man'>성인남성</MenuItem>
                                                <MenuItem value='Woman'>성인여성</MenuItem>
                                                <MenuItem value='Child'>아이</MenuItem>
                                                <MenuItem value='Elderly'>노인</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <>
                                            <IconButton className={classes.refreshIcon} disableRipple onClick={handleRefreshTTS}>
                                                <RefreshIcon />
                                            </IconButton>
                                        </>
                                    </Box>
                                    <Box className={classes.oddTextBox}>
                                        <Typography>{oddStepTwoStore.selectedContent.text}</Typography>
                                        <IconButton className={classes.volumeIconPosition} disableRipple style={{cursor: oddStepTwoStore.selectedContent.audio === null ? 'default' : 'pointer'}} onClick={() => handleClickAudio('main')}>
                                            {oddStepTwoStore.selectedContent.audio !== null ?
                                                <VolumeIcon /> :
                                                <VolumeDisableIcon />
                                            }
                                        </IconButton>
                                    </Box>
                                </Box>
                                <Box className={classes.textContnetScroll}>
                                    <Box className={classes.textContnetBox}>
                                        <Typography>본문 1</Typography>
                                        <Box className={clsx(classes.textContnet, (oddStepTwoStore.selectedSubContent === 1 ? classes.borderActive : null))}>
                                            {oddStepTwoStore.selectedContent && oddStepTwoStore.getPieceList(1).map((piece, index) => (
                                                <Box key={index} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                                    <Typography><span>{index + 1}</span> {oddStepTwoStore.getDividedText(piece.textStartIndex, piece.textEndIndex)} </Typography>
                                                    <IconButton className={classes.volumeIcon} disableRipple style={{cursor: (piece.audioStartTime === null && piece.audioFileName === null) ? 'default' : 'pointer'}} onClick={() => handleClickPieceAudio(`sub1-${index}`, piece)} disabled={(piece.audioStartTime === null && piece.audioFileName === null)}>
                                                        {(piece.audioStartTime != null || piece.audioFileName !== null) ?
                                                            <VolumeIcon /> :
                                                            <VolumeDisableIcon />
                                                        }
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-end"} >
                                        {/*본문 나누기 전*/}
                                        <Box className={clsx(classes.disabled, (oddStepTwoStore.isProcessingPosition ? null : classes.buttonStyle))}>
                                            <Button disableRipple disabled={oddStepTwoStore.isProcessingPosition} onClick={() => handleClickGeneratePosition(1)}>
                                                <Typography>좌표 생성</Typography>
                                            </Button>
                                        </Box>
                                        <Box className={clsx(classes.disabled, (oddStepTwoStore.isProcessingPosition ? null : classes.buttonStyle))} sx={{marginLeft: 10}}>
                                            <Button disableRipple disabled={oddStepTwoStore.isProcessingPosition} onClick={() => handleClickGenerateSound(1)}>
                                                <Typography>사운드 생성</Typography>
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Box className={classes.textContnetBox}>
                                        <Typography>본문 2</Typography>
                                        <Box className={clsx(classes.textContnet, (oddStepTwoStore.selectedSubContent === 2 ? classes.borderActive : null))}>
                                            {oddStepTwoStore.selectedContent && oddStepTwoStore.getPieceList(2).map((piece, index) => (
                                                <Box key={index} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                                    <Typography><span>{index + 1}</span> {oddStepTwoStore.getDividedText(piece.textStartIndex, piece.textEndIndex)} </Typography>
                                                    <IconButton className={classes.volumeIcon} disableRipple style={{cursor: (piece.audioStartTime === null && piece.audioFileName === null) ? 'default' : 'pointer'}} onClick={() => handleClickPieceAudio(`sub2-${index}`, piece)} disabled={(piece.audioStartTime === null && piece.audioFileName === null)}>
                                                        {(piece.audioStartTime != null || piece.audioFileName !== null) ?
                                                            <VolumeIcon /> :
                                                            <VolumeDisableIcon />
                                                        }
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-end"} >
                                        {/*본문 나누기 전*/}
                                        <Box className={clsx(classes.disabled, (oddStepTwoStore.isProcessingPosition ? null : classes.buttonStyle))}>
                                            <Button disableRipple disabled={oddStepTwoStore.isProcessingPosition} onClick={() => handleClickGeneratePosition(2)}>
                                                <Typography>좌표 생성</Typography>
                                            </Button>
                                        </Box>
                                        <Box className={clsx(classes.disabled, (oddStepTwoStore.isProcessingPosition ? null : classes.buttonStyle))} sx={{marginLeft: 10}}>
                                            <Button disableRipple disabled={oddStepTwoStore.isProcessingPosition} onClick={() => handleClickGenerateSound(2)}>
                                                <Typography>사운드 생성</Typography>
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </TabPanel>
                        ))}
                    </Box>
                </Box>
                <Box className={clsx(classes.rightBoxWrap, (oddStepTwoStore.isProcessingPosition ? classes.borderActive : null))}>
                    <Box>
                        <Typography>좌표 생성</Typography>
                    </Box>
                    <Box ref={anchorElRef} className={clsx(classes.rightTextBox, classes.imageBox)} aria-describedby={id} variant="contained" color="primary">
                        <Box className={classes.imageContent}>
                            <Box className={classes.imageBackground}>
                                {oddStepTwoStore.selectedContent && oddStepTwoStore.positionList.map((position, index) => {
                                    if (position != null && imageRef.current) {
                                        const displayPosition = getPosition(position.x, position.y);
                                        const x = displayPosition.x;
                                        const y = displayPosition.y;
                                        return (
                                            <Box id={`position-${index}`} key={index} className={classes.imageNumber} style={{left: x - 10, top: y - 10, pointerEvents: 'auto'}} draggable={true} onDragEnd={handleDrag}>
                                                <Typography>{index + 1}</Typography>
                                            </Box>
                                        )
                                    }
                                    return null;
                                })}
                            </Box>
                            {oddStepTwoStore.image === '' ?
                                <img src={NoImage} alt='NoImage'/> :
                                <img ref={imageRef} draggable={false} src={`data:image/png;base64,${oddStepTwoStore.image}`} alt='이미지' onClick={generatePosition}/>
                            }
                        </Box>
                    </Box>
                    <Popover
                        id={id}
                        open={oddStepTwoStore.popoverState === null ? false : oddStepTwoStore.popoverState}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        className={classes.popoverTooltip}
                    >
                        <Box className={classes.tooltipTop}>
                            <TooltipTipIcon />
                        </Box>
                        <Box display={'flex'} justifyContent={'flex-end'} className={classes.tooltipBtn}>
                            <Button disableRipple onClick={handleClosePopover}>
                                <TooltipClose />
                            </Button>
                        </Box>
                        <Typography className={classes.typography}>1. 이미지 위를 클릭하여 번호를 생성해 주세요.</Typography>
                        <Typography className={classes.typography}>2. 생성 된 번호를 드래그하여 번호 위치를 변경할 수 있습니다.</Typography>
                    </Popover>
                    <Box display={"flex"} justifyContent={"flex-end"} >
                        <Box className={clsx(classes.uncomplete, ((!oddStepTwoStore.isProcessingPosition || oddStepTwoStore.positionList.length < oddStepTwoStore.getPieceCount()) ? null : classes.complete))}>
                            <Button disableRipple disabled={!oddStepTwoStore.isProcessingPosition || oddStepTwoStore.positionList.length < oddStepTwoStore.getPieceCount()} onClick={handleClickSavePosition}>
                                <Typography>완료</Typography>
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {oddStepTwoStore.selectedContent &&
                <AudioPlayer audio={oddStepTwoStore.selectedContent.audio} regionCount={oddStepTwoStore.getPieceCount()} close={handleCloseGenerateSound} callback={handleFinishGenerateSound}/>
            }
        </Box>
    );
}

export default withRouter(inject('contentStore','oddStepTwoStore','audioPlayerStore')(observer(OddStepTwo)));
